import ReactDOM from "react-dom";

import App from "./components/App";

ReactDOM.render(<App />, document.querySelector(".root"));

/* DEPLOY VERCEL IN - bellasemijoias.vercel@gmail.com */
